export default __webpack_public_path__ + "static/media/mx-step-bg.9a25ba48.png";